/* Mirror of apps/mobile sign-in's error humanizer. Supabase auth errors come */
/* back as English technical strings; we surface kid/parent-friendly French */
/* equivalents instead. */

/** Compact French relative date label. Used in the sidebar and the thread list. */
export function relativeFr(iso: string | null): string {
  if (!iso) return '';
  const ms = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(ms / 60_000);
  if (mins < 1) return "à l'instant";
  if (mins < 60) return `il y a ${mins} min`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `il y a ${hours} h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `il y a ${days} j`;
  return new Date(iso).toLocaleDateString('fr-FR');
}
export function humanizeAuthError(raw: string): string {
  const m = raw.toLowerCase();
  if (m.includes('invalid login') || m.includes('credentials')) {
    return 'Email ou mot de passe incorrect. Réessaie ?';
  }
  if (m.includes('email rate limit')) {
    return 'Tu as essayé trop souvent. Attends quelques minutes.';
  }
  if (m.includes('user already registered') || m.includes('already been registered')) {
    return 'Ce compte existe déjà — connecte-toi à la place.';
  }
  if (m.includes('invalid email')) {
    return "L'email a l'air bizarre — vérifie qu'il n'y a pas de faute.";
  }
  if (m.includes('email not confirmed')) {
    return 'Confirme ton email avant de te connecter (lien dans ta boîte mail).';
  }
  return raw;
}
